import React from "react";

export const SpeechContext = React.createContext();
export const SpeechDispatchContext = React.createContext();

function SpeechProvider({children}) {
    const [state,setstate] = React.useState("")
    return(
        <SpeechContext.Provider value={state}>
            <SpeechDispatchContext.Provider value={setstate} >
                {children}
            </SpeechDispatchContext.Provider>
        </SpeechContext.Provider>
    )
}

export {SpeechProvider};
